define('app-formElements/main',["sumoselect"], function () {
    return {
        run: function () {
            $("input[data-lowercase='true']").on("blur", function () {
                $(this).val(function (_, val) {
                    return val.toLowerCase();
                });
            });

            $("input[type='checkbox']").change(function () {
                if ($(this).is(":checked")) {
                    $(this).next("label").addClass("checked");
                } else {
                    $(this).next("label").removeClass("checked");
                }
            });

            $("input[type='radio']").change(function () {
                $(this).parent(".radio-group, .radioGroup, .radioHolder").children("label").removeClass("checked");
                $(this).parent(".radio-group, .radioGroup, .radioHolder").children("li").removeClass("li_checked");

                if ($(this).is(":checked")) {
                    $(this).next("label").addClass("checked");
                    $(this).parentsUntil("li").addClass("li_checked");

                }
            });

            $(".selectGroup select").each(function () {
                var placeholderText = "Any departure point";

                if (this.id.includes("Duration")) {
                    var $duration = $("#" + this.id);
                    if ($duration.val() === null || $duration.val() === "") {
                        placeholderText = $("#"+ this.id +" option:eq(0)").val();
                        $duration.val(placeholderText);
                    }               
                }

                if (this.id.includes("Passengers")) {              
                    var $passengers = $("#" + this.id);
                    if ($passengers.val() === null || $passengers.val() === "") {
                        placeholderText = this.id === "soloTravellerPassengers" ? $("#" + this.id + " option:eq(0)").val()
                            : $("#" + this.id + " option:eq(1)").val();
                        $passengers.val(placeholderText);
                        $("#destinationDateField").val("Any date");
                    }   
                }

                if (this.id === "oceanCruiseLines") {
                    placeholderText = "All cruise lines";
                }

                if (this.id === "specialInterestSearchContentSelect") {
                    placeholderText = "All interests";
                }

                if (this.id === "hostsSearchContentSelect") {
                    placeholderText = "All hosts";
                }

                $(this).SumoSelect({
                    placeholder: placeholderText
                });
            });
        }
    }
});
